// Constants
import {
  ANDROID_NOT_DESKTOP_FALLBACK_URL,
  DESKTOP_FALLBACK_URL,
  IOS_NOT_DESKTOP_FALLBACK_URL,
} from 'utils/constants/app-callback-url.utils.constants';
// Utilities
import {
  isAndroidDevice,
  isAndroidNativeBrowser,
  isDesktopDevice,
  isIOSDevice,
  isMobileDevice,
  isSafariNativeBrowser,
  isTabletDevice,
} from '@openbank/cf-ui-framework';
import {
  INTENTIONAL_NAVIGATION,
  INTENTIONAL_NAVIGATION_ON,
} from 'components/header-layout/constants/header-layout.constants';
import { getCallbackUrl } from './browser-url.utils';

// eslint-disable-next-line complexity
const getFallbackCallbackUrl = (): string => {
  switch (true) {
    case (isMobileDevice() || isTabletDevice()) && (isAndroidDevice() || isAndroidNativeBrowser()):
      return ANDROID_NOT_DESKTOP_FALLBACK_URL;
    case (isMobileDevice() || isTabletDevice()) && (isIOSDevice() || isSafariNativeBrowser()):
      return IOS_NOT_DESKTOP_FALLBACK_URL;
    case isDesktopDevice():
      return DESKTOP_FALLBACK_URL;
    default:
      return DESKTOP_FALLBACK_URL;
  }
};

const navigateToCallbackUrl = (): void => {
  localStorage.setItem(INTENTIONAL_NAVIGATION, INTENTIONAL_NAVIGATION_ON);
  const callbackUrl = getCallbackUrl();
  const url: any = callbackUrl || getFallbackCallbackUrl();

  if (isMobileDevice() || isTabletDevice()) {
    window.location = url;
  } else {
    window.location.href = url;
  }
};

export { getFallbackCallbackUrl, navigateToCallbackUrl };
